import "./styles.css";
import { NeuroDriveApp } from "./ui/app";

const root = document.querySelector<HTMLDivElement>("#app");
if (!root) throw new Error("NeuroDrive root element is missing.");

new NeuroDriveApp(root).start().catch((error: unknown) => {
  const message = error instanceof Error ? error.message : "Ukendt startup-fejl";
  root.innerHTML = `
    <main class="fatal-error">
      <p class="eyebrow">STARTUP ERROR</p>
      <h1>NeuroDrive kunne ikke starte.</h1>
      <p>${message}</p>
      <button type="button" data-retry-startup>Prøv igen</button>
    </main>
  `;
  root.querySelector<HTMLButtonElement>("[data-retry-startup]")?.addEventListener("click", () => window.location.reload());
});
